<!-- collapse-mode -->
<div *ngIf="layout == 'collapse' && !isPrintMode"
    class="collapse-mode form-group"
    [class.all-collapsed]="isAllCollapsed"
    cdkDropList
    (cdkDropListDropped)="drop($event)"
    #repeaterContainer>

    <label for="" *ngIf="showTitle">
        {{ getTitle() }}
    </label>

    <div *ngIf="items.length == 0" class="collapse-placeholder">
        <p>{{ getEmptyRepeaterTitle(templateTitle.toLowerCase()) }}. 
            <button (click)="addDefault()" *ngIf="checkViewMode('edit')" type="button" class="btn btn-link">
                {{ getEmptyFirstMessage(templateTitle.toLowerCase()) }}
            </button>
        </p>
    </div>

    <p *ngIf="summaryField && items.length > 0">
        Total: {{ fieldsSum | mask: 'separator': '.' }} {{ hasFieldSumMaxValue ? "| Restam: " + (fieldSumMaxValue - fieldsSum) : "" }}
    </p>

    <div *ngFor="let item of paginatedItems; let i = index" 
        class="collapse-item"
        [class.has-error]="item.hasError"
        cdkDrag>
        
        <div class="drag-placeholder" *cdkDragPlaceholder></div>
        
        <div class="collapse-header">
            <input *ngIf="showItemCheckbox" type="checkbox" 
                [checked]="isChecked(item)" 
                (change)="onCheckboxChange($event, item)" 
                class="item-checkbox">

            <a class="collapse"
                role="button"
                [class.collapsed]="collapseMenuIndex !== i"
                [attr.aria-expanded]="collapseMenuIndex === i ? 'true' : 'false'"
                (click)="toggleCollapseMenu(i)">
                <ng-container *ngFor="let title of getItemTitle(item, i); let first = first">
                    <span [class.secondary-title]="!first" [innerHtml]="title | safeHtml"></span>
                </ng-container>
                <span style="margin-left: 10px;">{{ getOcurrencesNumber(currentItemTitle) }}</span>
                <i class="fa"></i>
            </a>

            <div *ngIf="checkViewMode('edit')" class="collapse-options">
                <div class="btn-group dropleft">
                    <button type="button" class="btn dropdown-toggle" 
                        data-toggle="dropdown" 
                        aria-haspopup="true" 
                        aria-expanded="false">
                        <div class="dots-icon">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                    </button>
                    <div class="dropdown-menu">
                        <ul>
                            <li>
                                <a (click)="onArrowUp(i)">
                                    <i class="fa fa-arrow-up"></i>
                                </a>
                            </li>
                            <li>
                                <a (click)="onArrowDown(i)">
                                    <i class="fa fa-arrow-down"></i>
                                </a>
                            </li>
                            <li>
                                <a (click)="onCopyToClipboard(item)">
                                    <i class="fa fa-copy"></i>
                                </a>
                            </li>
                            <li>
                                <a (click)="onCutToClipboard(item, i)">
                                    <i class="fa fa-cut"></i>
                                </a>
                            </li>
                            <li>
                                <a (click)="onRemove(i)">
                                    <i class="fa fa-trash"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="drag-handle" cdkDragHandle>
                <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
            </div>
        </div>

        <div class="collapse"
            [id]="getId(item)"
            [class.show]="collapseMenuIndex === i">
            <div class="collapse-body row">
                <app-dynamic *ngFor="let _item of item.attributes" 
                    [class]="getSizeClass(_item)" 
                    [attribute]="_item"
                    [envOptions]="getEnvOptions(item.key)" 
                    [parent]="item"
                    (onEmit)="handleEvent($event)">
                </app-dynamic>
            </div>
        </div>
    </div>

    <div *ngIf="checkViewMode('edit')" class="add">
        <button (click)="addDefault()" 
                *ngIf="items.length > 0" 
                [disabled]="!allowAddItems" 
                type="button" 
                class="btn btn-secondary rounded-circle">
            <i class="fa fa-plus"></i>
        </button>
        <button *ngIf="hasCopiedAttribute" (click)="paste()" 
                type="button" 
                class="btn btn-sm">
            <i class="fa fa-paste"></i> Colar Campo
        </button>
    </div>

    <div class="pagination-container" *ngIf="items.length > itemsPerPage">
        <nav aria-label="Navegação de páginas">
            <ul class="pagination">
                <li class="page-item" [class.disabled]="currentPage === 1">
                    <a class="page-link" href="javascript:void(0)" (click)="previousPage()">
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>
                
                <li class="page-item" *ngFor="let page of getPageNumbers()" [class.active]="page === currentPage">
                    <a class="page-link" href="javascript:void(0)" (click)="goToPage(page)">
                        {{ page }}
                    </a>
                </li>

                <li class="page-item" [class.disabled]="currentPage === totalPages">
                    <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</div>

<!-- Contador fixo -->
<div class="fixed-counter" *ngIf="showCheckedCounter">
    <p><strong>Total selecionado:</strong> R$ {{ totalSelectedValueFormated }}</p>
</div>

<!-- collapse-print-mode -->
<div *ngIf="layout=='collapse' && isPrintMode">
    
    <label for="" *ngIf="showTitle" class="title-collapse-print">
        {{ getTitle() }}
    </label>

    <div *ngFor="let item of items; index as i" 
        class="collapse-item">

        <div class="collapse-body row">
            <app-dynamic *ngFor="let _item of item.attributes" 
                [class]="getSizeClass(_item)" 
                [attribute]="_item"
                [envOptions]="getEnvOptions(item.key)" 
                [parent]="item"
                (onEmit)="handleEvent($event)">
            </app-dynamic>
        </div>
    </div>
</div>

<!-- tab-mode -->
<div *ngIf="layout=='tab' && !isPrintMode" class="tab-mode" [id]="getId(attribute)">
    <label for="" *ngIf="showTitle" class="tab-title">
        {{ getTitle() }}
    </label>

    <div *ngIf="items.length == 0" class="collapse-placeholder">
        <p>Você ainda não tem nenhum {{templateTitle.toLowerCase()}}. 
            <button (click)="addDefault()" *ngIf="checkViewMode('edit')" type="button" class="btn btn-link">Adicione o primeiro aqui.</button>
        </p>
    </div>

    <div class="tab-content">
        <div class="tab-header">
            <ul class="nav nav-tabs" 
                role="tablist"
                dndDropzone
                dndHorizontal="true"
                dndEffectAllowed="copyMove"
                (dndDrop)="onDrop($event)">

                <div dndPlaceholderRef class="btn-placeholder"></div>

                <li *ngFor="let item of items; index as i"
                    role="presentation"
                    class="nav-item"
                    [dndDraggable]="item.key"
                    dndEffectAllowed="move"
                    [class.has-error]="item.hasError"
                    [class.active]="tabMenuIndex === i">
                    <a [href]="'#' + getId(item)"
                        [attr.aria-controls]="getId(item)"
                        role="tab"
                        data-toggle="tab"
                        class="nav-link"
                        [class.active]="tabMenuIndex === i"
                        (click)="toggleTabMenu(i)">
                        <ng-container *ngFor="let title of getItemTitle(item, i); let first = first">
                            <span [class.secondary-title]="!first" [innerHtml]="title | safeHtml"></span>
                        </ng-container>
                        <span style="margin-left: 10px;">{{ getOcurrencesNumber(currentItemTitle) }}</span>

                        <div *ngIf="checkViewMode('edit')" class="collapse-options">
                            <button type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <div class="dots-icon">
                                    <span class="dot"></span>
                                    <span class="dot"></span>
                                    <span class="dot"></span>
                                </div>
                            </button>
                            <div class="dropdown-menu">
                                <ul>
                                    <li>
                                        <a (click)="duplicate(item, i)">
                                            <i class="fa fa-clone"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="onRemove(i)">
                                            <i class="fa fa-trash"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
            <div class="add-fase">
                <button *ngIf="checkViewMode('edit') && items.length > 0" type="button" class="btn btn-sm btn-secondary rounded-circle"
                    (click)="addDefault()">
                    <i class="fa fa-plus"></i>
                </button>
            </div>
        </div>

        <div class="tab-pane" *ngFor="let item of items; index as i" 
            [id]="getId(item)"
            [class.active]="tabMenuIndex === i"
            role="tabpanel">
            <div class="row">
                <app-dynamic *ngFor="let _item of item.attributes" 
                    [class]="getSizeClass(_item)" 
                    [attribute]="_item"
                    [envOptions]="getEnvOptions(item.key)" 
                    [parent]="item"
                    (onEmit)="handleEvent($event)">
                </app-dynamic>
            </div>
        </div>
    </div>
</div>

<!-- tab-print-mode -->
<div *ngIf="layout=='tab' && isPrintMode" class="tab-mode">
    <div class="tab-content">
        <div *ngFor="let item of items; index as i"
            [id]="getId(item)">

            <label class="title-tabs-print">
                <i class="fa fa-angle-right"></i> {{ getItemTitle(item, i) }}
            </label>

            <div class="row">
                <app-dynamic *ngFor="let _item of item.attributes" 
                    [class]="getSizeClass(_item)" 
                    [attribute]="_item"
                    [envOptions]="getEnvOptions(item.key)" 
                    [parent]="item"
                    (onEmit)="handleEvent($event)">
                </app-dynamic>
            </div>
        </div>
    </div>
</div>